import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import VideoDetail from '../cards/videoPage/VideoDetail';
import { useProfile } from '../contexts/ProfileContext';

function VideoPage({ hasCompletedVideos }) {
    // profile/user come from the shared ProfileContext. ``updateScore``
    // is the no-op-style refresh after a video finishes: the page calls
    // it on unmount so the header's score chip stays accurate, but
    // never wants the profile object itself to flip (which would
    // remount this page). ``fetchProfile(false)`` matches the old
    // App.js callback exactly.
    const { profile, user, fetchProfile } = useProfile();
    const updateScore = async () => fetchProfile(false);
    const [selectedVideoId, setSelectedVideoId] = useState(null);
    const [videoMeta, setVideoMeta] = useState(null);
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const video_id = searchParams.get('vid');
        const channel_id = searchParams.get('cid');
        const disableInteractiveFeatures = searchParams.get('lite') === '1';
        const title = searchParams.get('title');
        const channelTitle = searchParams.get('ctitle');
        const thumbnailUrl = searchParams.get('thumb');
        if (video_id) {
            setSelectedVideoId({ video_id, channel_id, disableInteractiveFeatures });
            setVideoMeta({ title, channelTitle, thumbnailUrl });
        }
    }, []);

    useEffect(() => {
        return () => {
            updateScore();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {
                selectedVideoId?.disableInteractiveFeatures &&
                <div className="flex full-w mb-4">
                    <button
                        className="text-gray-500 py-2 cursor-pointer hover:text-gray-700"
                        onClick={handleBack}
                    >
                        ← Back
                    </button>
                </div>
            }
            <VideoDetail
                profile={profile}
                user={user}
                videoId={selectedVideoId?.video_id}
                channelId={selectedVideoId?.channel_id}
                videoMeta={videoMeta}
                hasCompletedVideos={hasCompletedVideos}
                disableInteractiveFeatures={selectedVideoId?.disableInteractiveFeatures}
            />
        </div>
    );
};

export default VideoPage;
